import { c as _c } from "react/compiler-runtime";
import type { FC, HTMLProps } from "react";
import Image from "next/image";
import clsx from "clsx";
import { Link } from "../../interactives";
import style from "./Logo.module.scss";
import src from "../../../../../../public/logo-2500.png";
const Logo: FC<HTMLProps<HTMLAnchorElement>> = t0 => {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      href: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const href = t1 === undefined ? "/notes" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = clsx(style.link, className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image className={style.img} src={src} alt="Vita Learning logo" priority={true} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== href || $[8] !== props || $[9] !== t2) {
    t4 = <Link href={href} className={t2} {...props}>{t3}</Link>;
    $[7] = href;
    $[8] = props;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default Logo;